<template>
  <v-app-bar app color="white" flat fixed>
    <!-- Logo de Deltia -->
    <v-img
      @click="$router.push({ name: getHomeRoute || 'home' })"
      :src="require('@/assets/deltia.svg')"
      transition="scale-transition"
      alt="Logo de Deltia"
      aspect-ratio="1"
      class="shrink clickable-div"
      width="90"
      contain
    />
    <!-- Espaciado -->
    <v-spacer></v-spacer>
    <!-- Menú si el usuario no ha iniciado sesión -->
    <v-menu offset-y v-if="!isAuthenticated">
      <!-- Botón -->
      <template v-slot:activator="{ on }">
        <v-app-bar-nav-icon
          v-on="on"
          class="hidden-md-and-up"
        ></v-app-bar-nav-icon>
      </template>
      <!-- Lista de botones si el usuario no ha iniciado sesión-->
      <v-list>
        <v-list-item v-for="item in getMenuItems" :key="item.key">
          <SecondaryButton @click="$router.push({ name: item.key })">
            {{ item.title }}
          </SecondaryButton>
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- Menú si el usuario ya inició sesión -->
    <v-menu offset-y v-else>
      <!-- Botón -->
      <template v-slot:activator="{ on }">
        <v-app-bar-nav-icon
          v-on="on"
          class="hidden-md-and-up"
        ></v-app-bar-nav-icon>
      </template>
      <!-- Lista de botones si el usuario ya ha iniciado sesión-->
      <v-list>
        <!-- Menú -->
        <v-list-item v-for="item in getMenuItems" :key="item.key">
          <!-- Botón -->
          <v-btn
            @click="$router.push({ name: item.key })"
            color="secondary"
            text
          >
            <!-- Icono -->
            <v-list-item-icon>
              <v-icon>
                {{ item.icon }}
              </v-icon>
            </v-list-item-icon>
            {{ item.title }}
          </v-btn>
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- Botones si el usuario no ha iniciado sesión - Pantallas grandes -->
    <v-toolbar-items v-if="!isAuthenticated" class="hidden-sm-and-down">
      <v-list-item v-for="item in getMenuItems" :key="item.key">
        <SecondaryButton @click="$router.push({ name: item.key })">
          {{ item.title }}
        </SecondaryButton>
      </v-list-item>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
const SecondaryButton = () => import("@/components/SecondaryButton");
import { mapGetters } from "vuex";

export default {
  name: "NavigationBar",
  components: {
    SecondaryButton
  },
  computed: {
    currentRoute: function() {
      return this.$route.name;
    },
    ...mapGetters([
      "getHomeRoute",
      "isAuthenticated",
      "getProfile",
      "getMenuItems"
    ])
  }
};
</script>
<style scoped>
.clickable-div {
  cursor: pointer;
}
</style>
